'use strict';

export default () => {
  const items = document.querySelectorAll(".section-faq__accordion-item");

  items.forEach(item => {
    const question = item.querySelector(".section-faq__accordion-item__header");

    question.addEventListener("click", () => {
      item.classList.toggle("active");
    });
  });
}
